import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en';
import fr from './fr';
import fr_ca from './fr-ca';
import de from './de';
import es from './es';
import ja from './ja';
import it from './it';
var nameSpaceList = [
    'siders',
    'meetingRooms',
    'modal',
    'spaceBooking',
    'workplaceService',
];
var resources = {
    en: en,
    fr: fr,
    'fr-CA': fr_ca,
    de: de,
    es: es,
    ja: ja,
    it: it,
};
var getInitialLanguage = function () {
    if (typeof window === 'undefined')
        return 'en';
    var stored = localStorage.getItem('i18nextLng');
    if (stored && Object.keys(resources).includes(stored))
        return stored;
    var browser = navigator.language;
    var resourceKeys = Object.keys(resources);
    if (resourceKeys.includes(browser))
        return browser;
    var baseLang = browser.split('-')[0];
    return resourceKeys.includes(baseLang) ? baseLang : 'en';
};
var i18n = i18next.createInstance().use(initReactI18next);
i18n.use(initReactI18next).init({
    resources: resources,
    ns: nameSpaceList,
    defaultNS: 'meetingRooms',
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});
export { i18n };
